import { MAJOR_NAMES } from './majors';
import { UNIVERSITY_NAMES } from './universities';

export const DEGREE_OPTIONS = ['高中及以下', '中专', '大专', '本科', '硕士', '博士', '博士后'] as const;

// 教育部名单未收录的科研院所，以及部分港澳院校之外的补充。
const EXTRA_SCHOOLS = [
  '中国科学院过程工程研究所',
  '中国科学院大连化学物理研究所',
  '中国科学院山西煤炭化学研究所',
  '中国科学院上海高等研究院',
  '中国科学院广州能源研究所',
  '中国科学院工程热物理研究所',
  '中国科学院青岛生物能源与过程研究所',
  '中国科学院深圳先进技术研究院',
  '中国科学院理化技术研究所',
  '中国科学院化学研究所',
  '中国科学院生态环境研究中心',
];

export const SCHOOL_SUGGESTIONS = Array.from(new Set([...UNIVERSITY_NAMES, ...EXTRA_SCHOOLS]));

// 与碳捕集方向相关的专业排在前面，其余为教育部专业目录全量名单。
const CORE_MAJORS = [
  '化学工程与工艺',
  '化学工程',
  '化学工程与技术',
  '能源化学工程',
  '应用化学',
  '化学',
  '材料科学与工程',
  '材料与化工',
  '高分子材料与工程',
  '无机非金属材料工程',
  '复合材料与工程',
  '新能源材料与器件',
  '储能科学与工程',
  '碳储科学与工程',
  '环境工程',
  '环境科学与工程',
  '环境科学',
  '资源与环境',
  '能源与动力工程',
  '动力工程及工程热物理',
  '过程装备与控制工程',
  '安全工程',
  '石油工程',
  '油气储运工程',
  '地质工程',
  '地质资源与地质工程',
  '地球化学',
  '地球物理学',
  '采矿工程',
  '矿物加工工程',
  '机械工程',
  '自动化',
  '电气工程及其自动化',
  '计算机科学与技术',
  '人工智能',
  '数据科学与大数据技术',
  '生物工程',
  '制药工程',
  '生态学',
  '大气科学',
  '海洋科学',
  '水文与水资源工程',
  '给排水科学与工程',
  '建筑环境与能源应用工程',
  '工业工程',
  '管理科学与工程',
];

export const MAJOR_SUGGESTIONS = Array.from(new Set([...CORE_MAJORS, ...MAJOR_NAMES]));

const NEWEST_YEAR = new Date().getFullYear() + 10;

export const YEAR_OPTIONS: string[] = Array.from(
  { length: NEWEST_YEAR - 1995 + 1 },
  (_, index) => String(NEWEST_YEAR - index),
);

export const MONTH_OPTIONS = Array.from({ length: 12 }, (_, index) => {
  const value = String(index + 1).padStart(2, '0');
  return { value, label: `${value} 月` };
});

export function rankSuggestion(option: string, query: string): number {
  const haystack = option.toLowerCase();
  const needle = query.trim().toLowerCase();
  if (!needle) return 0;
  if (haystack === needle) return 10_000;
  const direct = haystack.indexOf(needle);
  if (direct === 0) return 8_000 - haystack.length;
  if (direct > 0) return 6_000 - direct * 10 - haystack.length;
  let cursor = 0;
  let last = -1;
  let gaps = 0;
  for (const char of needle) {
    const found = haystack.indexOf(char, cursor);
    if (found === -1) return -1;
    if (last >= 0) gaps += found - last - 1;
    last = found;
    cursor = found + 1;
  }
  const startBonus = haystack.startsWith(needle[0]) ? 300 : 0;
  return 3_000 + startBonus - gaps * 20 - haystack.length;
}
